export default class CompanyDataType {
    name: string;
    path: string;
    rnc: string;
    username: string;
    
    constructor() {
        this.name = "";
        this.path = "";
        this.rnc = "";
        this.username = "";
    }    
}